import { NgInitDirective } from './components/ng-init-directive';
import { NgModule} from '@angular/core';

@NgModule ({

    declarations: [
        NgInitDirective        
    ],
    exports: [
        NgInitDirective
    ]

})

export class NgInitDirectiveModule { }